import PageHeader from "components/PageHeader";
import LocationMap, { AVIARY_DIRECTIONS_URL } from "components/LocationMap";

const contactItems = [
  {
    icon: "📍",
    title: "Address",
    lines: ["Jojo Street, Baesa", "Quezon City, 1106 Philippines"],
  },
  {
    icon: "📞",
    title: "Phone",
    lines: ["(555) 123-BIRD", "(555) 123-2473"],
  },
  {
    icon: "✉️",
    title: "Email",
    lines: ["info@mysheraviary.com", "visits@mysheraviary.com"],
  },
  {
    icon: "🕒",
    title: "Hours",
    lines: ["Mon-Sun: 9:00 AM - 6:00 PM", "Closed major holidays"],
  },
];

const inputClasses =
  "w-full rounded-lg border-2 border-[#e9ecef] p-3 text-base transition-colors duration-300 focus:border-primary-blue focus:outline-none";

const Contact = () => {
  return (
    <div className="min-h-screen pt-0">
      <PageHeader
        title="Contact Us"
        subtitle="Get in touch with our team for visits, appointments, or inquiries"
      />

      <div className="bg-white py-20 max-[768px]:py-[60px]">
        <div className="container">
          <div className="grid grid-cols-2 items-start gap-16 max-[968px]:grid-cols-1 max-[968px]:gap-8">
            <div className="mb-12">
              <h2 className="mb-8 text-4xl font-bold text-primary-blue max-[768px]:text-3xl">
                Contact Information
              </h2>
              <div className="my-8 grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-8">
                {contactItems.map((item) => (
                  <div key={item.title}>
                    <h3 className="mb-2 text-lg text-primary-blue">
                      {item.icon} {item.title}
                    </h3>
                    <p className="mb-0 leading-relaxed text-text-light">
                      {item.lines.map((line, i) => (
                        <span key={i}>
                          {line}
                          {i < item.lines.length - 1 && <br />}
                        </span>
                      ))}
                    </p>
                  </div>
                ))}
              </div>

              <div className="mt-8 rounded-xl bg-[#f8f9fa] p-8 text-center">
                <h3 className="mb-4 text-primary-blue">
                  Schedule an Appointment
                </h3>
                <p>Book your visit or consultation with our bird experts.</p>
                <button className="btn btn-primary mt-4">
                  Create an Appointment
                </button>
              </div>
            </div>

            <div className="mb-12">
              <h2 className="mb-8 text-4xl font-bold text-primary-blue max-[768px]:text-3xl">
                Contact Form
              </h2>
              <form className="rounded-xl bg-[#f8f9fa] p-8">
                <div className="mb-6">
                  <label
                    htmlFor="name"
                    className="mb-2 block font-semibold text-text-dark"
                  >
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className={inputClasses}
                  />
                </div>

                <div className="mb-6">
                  <label
                    htmlFor="email"
                    className="mb-2 block font-semibold text-text-dark"
                  >
                    Email Address
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className={inputClasses}
                  />
                </div>

                <div className="mb-6">
                  <label
                    htmlFor="phone"
                    className="mb-2 block font-semibold text-text-dark"
                  >
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    className={inputClasses}
                  />
                </div>

                <div className="mb-6">
                  <label
                    htmlFor="subject"
                    className="mb-2 block font-semibold text-text-dark"
                  >
                    Subject
                  </label>
                  <select
                    id="subject"
                    name="subject"
                    required
                    className={inputClasses}
                  >
                    <option value="">Select a topic</option>
                    <option value="visit">Visit Information</option>
                    <option value="appointment">Appointment Request</option>
                    <option value="education">Educational Programs</option>
                    <option value="conservation">
                      Conservation Programs
                    </option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="mb-6">
                  <label
                    htmlFor="message"
                    className="mb-2 block font-semibold text-text-dark"
                  >
                    Message
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows={5}
                    required
                    className={inputClasses}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primary"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>

          <div className="mt-16">
            <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
              <h2 className="text-4xl font-bold text-primary-blue max-[768px]:text-3xl">
                Find Us
              </h2>
              <a
                href={AVIARY_DIRECTIONS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary"
              >
                Get Directions
              </a>
            </div>
            <LocationMap height="450px" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
